'use es6';

import { createSelector } from 'reselect';
import * as RequestKey from '../constants/RequestKey';

const getRequestStates = state => state.requestStates;

export const getAppIntegrationsRequestState = createSelector([getRequestStates], requestStates => requestStates[RequestKey.APP_INTEGRATIONS]);
export const getAdminRequestState = createSelector([getRequestStates], requestStates => requestStates[RequestKey.ADMINS]);
export const getPortalScopeRequestState = createSelector([getRequestStates], requestStates => requestStates[RequestKey.HUBS]);
export const getReviewWriteRequestState = createSelector([getRequestStates], requestStates => requestStates[RequestKey.REVIEW_WRITE]);
export const getReviewsFetchRequestState = createSelector([getRequestStates], requestStates => requestStates[RequestKey.REVIEWS_FETCH]);
export const getReviewStatsRequestState = createSelector([getRequestStates], requestStates => requestStates[RequestKey.REVIEWS_STATS]);
export const getFeatureCompatibilityRequestState = createSelector([getRequestStates], requestStates => requestStates[RequestKey.FEATURE_COMPATIBILITY]);